import { useEffect } from 'react';

interface UseCloseMenuOnScrollParams {
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

const useCloseMenuOnScroll = ({ anchorEl, onClose }: UseCloseMenuOnScrollParams) => {
  useEffect(() => {
    if (!anchorEl) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          setTimeout(onClose, 100);
        }
      },
      { threshold: 0 },
    );

    observer.observe(anchorEl);

    return () => {
      observer.disconnect();
    };
  }, [anchorEl, onClose]);
};

export default useCloseMenuOnScroll;
